import React from "react";
import styled from "styled-components";
import { ReloadOutlined } from "uiCore";

const StyledButton = styled.button`
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.focusShadow};
  }
`;

const SbRefreshButton = ({ onClick, title = "Refresh Data" }) => (
  <StyledButton type="button" onClick={onClick} title={title} aria-label={title}>
    <ReloadOutlined />
  </StyledButton>
);

export default SbRefreshButton;
